export class AppConsts {
    static readonly DefaultTitle = 'UPM - Gestion de competencias';
    static readonly Hyphen = '-';
    static readonly GrafanaConfigurationName = 'grafana';
    static readonly AppName = 'CareerCompetencies';
    static readonly MaxPageSize = 1000;
    static readonly RefreshTabsEvent = 'refreshTabs';
    static readonly LocalStorageKey = 'storage';
    static readonly GdprNavigationMenuItemName = 'Gdpr.GdprNavigation';
    static readonly ChangeCurrentPlaceMenuItemName = 'change-current-place';
    static readonly AnswerGroupClassificationScoreEnabledToRepeat = 0;
    static readonly MinHtmlCharactersRequired = 7;
    static readonly CalibrationsParam = 'calibrations';
    static readonly DateFormat = 'dd/MM/yyyy';
    static readonly DefaultMaxResultCount = 10;
    static readonly DefaultMonthForReport = 3;
    static readonly DefaultCharactersForWrap = 20;
    static readonly AreaSubAreaDivider = ' | ';
}
